:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;

  ::part(item-group-icons) {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    white-space: normal;
    padding-bottom: 0 !important;
  }

  ::part(grid-cell-icon) {
    height: 100%;
    display: inline-flex;
  }
}

.push-body {
  &--menu {
    display: none;
  }
}

.push-body,
.push-body--content {
  height: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;

  &.is-loading {
    .company-selector-loader {
      display: block;
    }

    .company-selector {
      display: none;
    }
  }

  &.is-error {
    .risk-management-header,
    .risk-management-content {
      display: none;
    }

    .loading-error {
      display: block;
    }
  }
}

.full-height-cell {
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  pointer-events: all;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.company-selector-loader {
  display: none;
  width: 160px;
}
.loader {
  margin-top: calc(2 * var(--spacer));

  .smartview-loader {
    padding-right: calc(2 * var(--spacer));
    padding-left: calc(3 * var(--spacer));
    position: relative;

    &:last-child {
      padding-top: var(--spacer);
    }

    &:not(:first-of-type) {
      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        height: 1px;
        width: calc(100% - calc(5 * var(--spacer)));
        left: calc(3 * var(--spacer));
        background-color: var(--secondary-color-10);
      }
    }

    &:first-child {
      padding-bottom: calc(2 * var(--spacer));
    }
  }
}

.risk-management-header {
  display: flex;
  flex-direction: column;
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 2.5) calc(var(--spacer) * 3) calc(var(--spacer) * 2.5);
  height: 64px;

  &--top {
    display: flex;
    justify-content: space-between;
  }
}

.title {
  color: var(--main-titles-inputs-600);
}

.subtitle {
  color: var(--chart-300-icon-buttons);
}

.loading-error {
  display: none;
  height: auto;
  width: 500px;
  margin: auto;

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}

.risk-management-content {
  flex-grow: 2;
  height: 100%;

  .risk-management-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}

gz-push-body-layout[resizable][isopen]::part(header) {
  margin-bottom: calc(2 * var(--spacer));
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
  text-transform: uppercase;
}

gz-push-body-layout[resizable][isopen]::part(sideNav) {
  min-width: 240px;
}

gz-push-body-layout[isopen] div[slot='push-body-sidenav'] {
  height: 100%;
}

gz-button[class*='action-split-button'] {
  &::part(button) {
    padding: 0 calc(1 * var(--spacer)) 0 calc(2 * var(--spacer));
  }
}

.header-buttons {
  padding-right: calc(2 * var(--spacer));
  margin-right: calc(2 * var(--spacer));
  position: relative;
  display: flex;

  .action-button {
    display: flex;
    align-items: center;

    .action-icon {
      font-size: 30px;
    }
  }

  gz-select[class*='no-margin'] {
    margin-left: -16px;
  }
}
